import React from "react";
import { default as Birthdays } from "components/Dashboard/Dashboard_Birthdays"
import { WIDGET_NAMES } from "components/WidgetTemplates/utils";
import { useTranslation } from "react-i18next";

const Card_Birthdays = (props) => {
	// console.log(props);
	const { t } = useTranslation();

	return (
		<article className="card card-birthday">
			<div className="card-top">
				<h2>{t(WIDGET_NAMES[props.name])}</h2>
			</div>
			<div className="card-content">
				<Birthdays />
			</div>
		</article>
	);
};

export default Card_Birthdays;